import './index.css';

function BodyManage({children}){
  return (
    <>
        <div className="body_container2 p-3">
            <div className="body_element" style={{marginBottom: '20px'}}>
            </div>
            <div className="children">
                {/* components children */}
                {children}
            </div>
        </div>
    </>
  );
}
export default BodyManage;